import React, { createContext } from "react";

const GuestContext = React.createContext();

export {
    GuestContext
}